
const Page = cc.Enum({
    MAIN: 'main-menu',
    AUTOPLAY: 'autoplay',
    BET: 'bet',
    GAME_RULES: 'gameRules',
    PAYTABLE: 'paytablePage',
    HISTORY: 'historyPage',
    REALITY_CHECK: 'realityCheck',
    INFO_POPUP: 'infoPopup',
});
const Events = require('PSEvents');
const State = require('PSState');
const InfoPopupController = require('InfoPopupController');
const SlotUI = require('./SlotUI');
const { MenuElements, UIComponentImplementationTypes } = require('./SlotUI');
const { disableSpinButton } = require('../Modules/PSUIControl');

cc.Class({
    extends: cc.Component,

    properties: {
        autoplayPage: cc.Node,
        autoplayPageUKGC: cc.Node,
        mainPage: cc.Node,
        betPage: cc.Node,
        historyPage: cc.Node,
        gameRulesPage: cc.Node,
        realityCheckPage: cc.Node,

        gameRulesButton: cc.Button,
        paytableButton: cc.Button,
        historyButton: cc.Button,

        infoPopup: InfoPopupController,

        payTableDefaultPrefab: cc.Prefab,
    },

    onLoad() {
        this.originalScaleX = this.node.scaleX;
        this.originalScaleY = this.node.scaleY;

        this.isPaused = false;
        this._pausedAnims = [];

        /**
         * Init Paytable
         */
        let paytablePrefab = this.payTableDefaultPrefab;

        const paytableHolder = cc.find('PSPaytableHolder');


        if (paytableHolder) {
            paytablePrefab = paytableHolder.getComponent('PSPaytableHolder').paytablePrefab
        }

        // It is important to instantiate paytable prefab, before we set this.node.active = false,
        // otherwise the paytable widget is not updated
        this.paytablePage = cc.instantiate(paytablePrefab);
        this.paytablePage.on('close', this.backButtonClick, this);
        this.paytablePage.parent = this.node;
        this.paytablePage.active = true;

        this.node.active = false;

        /**
         * Remove keyboard button for mobiles from the menu
         */
        /* if (Platform.isMobile) {
            const keyboardButton = this.keyboardToggle.node.parent;

            keyboardButton.active = false;
            keyboardButton.parent.children[keyboardButton.getSiblingIndex()-1].active = false;
        } */
    },

    initPaytable() {
        const paytableConfig = SlotUI.getMenuElement(MenuElements.Paytable);

        if (paytableConfig.enabled) {
            if (paytableConfig.implementationType === UIComponentImplementationTypes.BUILTIN) {
                this.openPaytable = () => {
                    this.paytablePage.active = true;
                    this.paytablePage.getComponent(cc.Widget).updateAlignment();
                };
            } else {
                this.openPaytable = () => {
                    paytableConfig.clickHandler().then(() => {
                        this.backButtonClick();
                    });
                };
            }
        } else {
            // This will make sure that the user won't able to open paytables
            this.paytableButton.node.active = false;
        }
    },

    initGameRules(gameBaseURL, language) {
        const gamerulesConfig = SlotUI.getMenuElement(MenuElements.GameRules);

        if (gamerulesConfig.enabled) {
            if (gamerulesConfig.implementationType === UIComponentImplementationTypes.BUILTIN) {
                this.openGameRules = () => {
                    this.gameRulesPage.active = true;
                    this.gameRulesPage.getComponent(cc.Widget).updateAlignment();;
                };
            } else {
                this.openGameRules = () => {
                    gamerulesConfig.clickHandler().then(() => {
                        this.backButtonClick();
                    });
                };

                this.node.on('closed', () => {
                    window.PSGames.CommonAPI.GameRules.close();
                })
            }
            const url = gamerulesConfig.url ?
                gamerulesConfig.url() :
                gameBaseURL + `game-rules/${language}/index.html`;

            const webView = this.gameRulesPage.getComponentInChildren(cc.WebView);
            webView.url = url;
        } else {
            // This will make sure that the user won't able to open gamerules
            this.gameRulesButton.node.active = false;
        }
    },

    initHistory() {
        const historyConfig = SlotUI.getMenuElement(MenuElements.History);

        if (historyConfig.enabled) {
            if (historyConfig.implementationType === UIComponentImplementationTypes.BUILTIN) {
                this.openHistory = () => {
                    this.historyPage.active = true;
                    this.node.emit('historyRequest');
                    // this.historyPage.getComponent(cc.Widget).updateAlignment();
                    if (historyConfig.clickHandler) {
                        historyConfig.clickHandler().then((e) => {
                            cc.log('HISTORY CLOSE', e);
                        });
                    }
                };
            } else {
                this.openHistory = () => {
                    historyConfig.clickHandler().then(() => {
                        this.backButtonClick();
                    });
                };
            }

            if (PSGames.launchParams.areEventsReplayEnabled) {
                Events.subscribe(Events.START_REPLAY, this.onStartReplay, this);
                Events.subscribe(Events.STOP_REPLAY, this.onStopReplay, this);
                Events.subscribe(Events.GAME_RESUMED, this.onGameResumed, this);
                Events.subscribe(Events.GAME_ROUND_ENDED, this.enableHistoryButton, this);
                Events.subscribe(Events.SPIN_REQUEST, this.disableHistoryButton, this);
            }
        } else {
            // This will make sure that the user won't able to open history
            this.historyButton.node.active = false;
        }
    },

    onDestroy() {
        PSEvents.removeAllListenerByTarget(this);
    },

    onStartReplay() {
        this._resume();
        cc.director.resume();
    },

    onStopReplay() {
        cc.director.pause();
    },

    onGameResumed(data) {
        if (data && data.isExitReplay) {
            const { isExitReplay } = data;

            if (isExitReplay) {
                cc.director.resume();

                this._pause();

                disableSpinButton();
            };
        }

    },

    enableHistoryButton() {
        if (!SlotUI.isReplayMode()) {
            this.historyButton.node.active = true;
        }
    },

    disableHistoryButton() {
        if (!SlotUI.isReplayMode()) {
            this.historyButton.node.active = false;
        }
    },

    keyboardToggled() {
        this.node.emit('keyboardToggled', this.keyboardToggle.isChecked);
    },

    masterVolumSlider() {
        this.node.emit('updateSoundsTriggered', { masterVolume: Math.round(this.masterVolume.progress * 10) });
    },

    musicVolumSlider() {
        this.node.emit('updateSoundsTriggered', { musicVolume: Math.round(this.musicVolume.progress * 10) });
    },

    fxVolumSlider() {
        this.node.emit('updateSoundsTriggered', { fxVolume: Math.round(this.fxVolume.progress * 10) });
    },

    updateState(state) {
        this.autoplayController.updateState(state);

        this.historyButton.interactable = !!state.playHistoryEnabled;
    },

    setAutoplay(isExtended) {
        if (isExtended) {
            this.autoplayPage.destroy();
            this.autoplayPage = this.autoplayPageUKGC;
        } else {
            this.autoplayPageUKGC.destroy();
            State.autoplaySelectedMaxLoss = 0;
            State.autoplaySelectedMaxWin = 0;
        }
        this.autoplayController = this.autoplayPage.getComponent('AutoplayController');
    },

    _hideAll() {
        this.mainPage.active = false;
        this.autoplayPage.active = false;
        this.autoplayPageUKGC.active = false;
        this.betPage.active = false;
        this.historyPage.active = false;
        this.paytablePage.active = false;
        this.gameRulesPage.active = false;
        this.realityCheckPage.active = false;
        this.infoPopup.node.active = false;
    },

    open(page = Page.MAIN, data) {
        if (!this.isPaused) {
            this._pause();
        }
        this.page = page;
        this.node.active = true;
        this._hideAll();
        switch (this.page) {
            case Page.MAIN:
                this.mainPage.active = true;
                this.mainPage.getComponent(cc.Widget).updateAlignment();
                break;
            case Page.BET:
                this.betPage.active = true;
                this.betPage.getComponent(cc.Widget).updateAlignment();
                break;
            case Page.AUTOPLAY:
                this.autoplayPage.active = true;
                this.autoplayPage.getComponent(cc.Widget).updateAlignment();
                break;
            case Page.GAME_RULES:
                this.openGameRules();
                break;
            case Page.PAYTABLE:
                this.openPaytable();
                break;
            case Page.HISTORY:
                this.openHistory();
                break;
            case Page.REALITY_CHECK:
                this.realityCheckPage.active = true;
                this.realityCheckPage.getComponent('RealityCheck').setData(data);
                this.realityCheckPage.getComponent(cc.Widget).updateAlignment();
                break;
            case Page.INFO_POPUP:
                this.infoPopup.open(data);
                break;
        }

        this.node.emit('opened', page);
    },

    close() {
        this._resume();
        this.page = null;
        this.node.active = false;
        this.node.emit('closed');
    },

    isOpened(page = null) {
        if (page === null) {
            return this.node.active;
        }

        return page === this.page;
    },

    backButtonClick() {
        switch (this.page) {
            case Page.INFO_POPUP:
                if (this.infoPopup.closeEnabled) {
                    this.close();
                }
                break;
            case Page.REALITY_CHECK:
                break;
            case Page.MAIN:
            case Page.BET:
            case Page.AUTOPLAY:
                this.close();
                break;
            case Page.GAME_RULES:
            case Page.PAYTABLE:
            case Page.HISTORY:
                this.open(Page.MAIN);
                break;
        }
    },

    historyButtonClick() {
        this.open(Page.HISTORY);
    },
    autoplayButtonClick() {
        if (this.page === Page.AUTOPLAY) {
            this.close();
        } else {
            this.open(Page.AUTOPLAY);
        }
    },
    paytableButtonClick() {
        this.open(Page.PAYTABLE);
    },
    gameRulesButtonClick() {
        this.open(Page.GAME_RULES);
    },

    _pause() {
        this.isPaused = true;
        this.actionTargets = cc.director.getActionManager().pauseAllRunningActions();
        this.schedulerTargets = cc.director.getScheduler().pauseAllTargetsWithMinPriority();
        // eslint-disable-next-line no-underscore-dangle
        const iterator = cc.director.getAnimationManager()._anims;
        const array = iterator.array;
        for (iterator.i = 0; iterator.i < array.length; ++iterator.i) {
            var anim = array[iterator.i];
            // eslint-disable-next-line no-underscore-dangle
            if (!anim._isPaused) {
                this._pausedAnims.push(anim);
                anim.pause();
            }
        }
        sp.timeScale = 0;
        this.node.emit('pause');
    },

    _resume() {
        this.isPaused = false;
        cc.director.getActionManager().resumeTargets(this.actionTargets);
        cc.director.getScheduler().resumeTargets(this.schedulerTargets);
        // eslint-disable-next-line no-underscore-dangle
        for (let i = 0; i < this._pausedAnims.length; i++) {
            var anim = this._pausedAnims[i];
            // eslint-disable-next-line no-underscore-dangle
            if (anim._isPaused) {
                anim.resume();
            }
        }
        this._pausedAnims.length = 0;
        sp.timeScale = 1;
        this.node.emit('resume');
    },
});
